import React from 'react'
import BadgesStarIcon from 'svg/badges-star.svg'
import BadgesSmileIcon from 'svg/badges-smile.svg'
import BadgesGlobeIcon from 'svg/badges-globe.svg'
import BadgesDollarIcon from 'svg/badges-dollar.svg'

const { ALGOLIA_APPLICATION_ID, ALGOLIA_SEARCH_API } = process.env

export const DEFAULT_APP = '/saatchi/artdetail2'
export const DEFAULT_URL = ''
export const applicationId: string = ALGOLIA_APPLICATION_ID || ''
export const searchApi: string = ALGOLIA_SEARCH_API || ''
// Product Status
export const SOLD = 'sold'
export const AVAILABLE = 'avail'
export const RESERVED = 'reserved'
export const SOLD_OUT = 'soldOut'
export const FOR_SALE = 'forSale'
export const NOT_FOR_SALE = 'notForSale'
// Carousel Api Types
export const ALGOLIA = 'algolia'
export const VISII = 'visii'
export const GOOGLE = 'google'
// Product View Types
export const ARTWORK = 'art' // Original || Info ( no products )

export const PRINT = 'print' // OpenEdition || LimitedEdition

// Product Tab Names/Labels
export const OPEN_EDITION_TAB = 'Prints'
export const LIMITED_EDITION_TAB = 'Limited Editions'
// Product Types
export const ORIGINAL = 'original'
export const OPEN_EDITION = 'open'
export const LIMITED_EDITION = 'limited'
// Print Materials
export const CANVAS = 'Canvas'
export const PHOTO_PAPER = 'Photo Paper'
export const FINE_ART_PAPER = 'Fine Art Paper'
export const ACRYLIC = 'Acrylic'
export const METAL = 'Metal'
export const METAL_LIGHT_PEWTER = 'Metal: Light Pewter'
export const METAL_DARK_PEWTER = 'Metal: Dark Pewter'
// Framing types
export const FRAMING_TYPE_ID_LIGHT_PEWTER = 12
export const FRAMING_TYPE_ID_DARK_PEWTER = 13
// Canvas wrap colors
export const CANVAS_WRAP_COLOR_WHITE = 'White Canvas'
export const CANVAS_WRAP_COLOR_BLACK = 'Black Canvas'
// Packaging Types
export const ROLLED = 'rolled'
export const FLAT_CARDBOARD = 'flat_cardboard'
export const FLAT_CRATE = 'flat_crate'
// Packaging Option Values
export const ROLLED_IN_TUBE = 'Ships Rolled in a Tube'
export const CRATE = 'Ships in a Crate'
export const BOX = 'Ships in a Box'
// Frame Options
export const NOT_FRAMED = 'Not Framed'
export const NOT_APPLICABLE = 'Not Applicable'
// Artwork Description Section
// Shipping & Returns constants
export const DELIVERY_TIME_COPY =
  'Typically 5-7 business days for domestic shipments, 10-14 business days for international shipments.'
export const ACRYLIC_DELIVERY_TIME_COPY =
  'Typically 12-17 business days for domestic shipments, 17-21 business days for international shipments.'
export const METAL_DELIVERY_TIME_COPY =
  'Typically 10-14 business days for domestic shipments, 15-21 business days for international shipments.'
export const COUNTRIES_CUSTOMS_APPLICABLE = [
  'Argentina',
  'Armenia',
  'Brazil',
  'Bolivia',
  'Bulgaria',
  'Chile',
  'China',
  'Colombia',
  'Croatia',
  'Germany',
  'Greece',
  'India',
  'Italy',
  'Mexico',
  'Montenegro',
  'Poland',
  'Romania',
  'Russia',
  'Serbia',
  'Spain',
  'Slovakia',
  'Ukraine',
  'United Kingdom',
  'Venezuela',
]
export const RETURN_POLICY_LINK = 'https://support.saatchiart.com/hc/en-us/articles/14673570463643 '
export const HELP_SECTION_LINK = 'https://support.saatchiart.com/hc/en-us/categories/200254317'
export const CONTACT_US_LINK = 'https://support.saatchiart.com/hc/en-us/requests/new'
export const ART_ADVISORY_LINK = 'https://www.saatchiart.com/artadvisory'
export const PACKAGING_GUIDELINES_LINK =
  'https://support.saatchiart.com/hc/en-us/articles/14709932602139'
export const ROLLED_IN_TUBE_TEXT = 'Ships rolled in a tube.'
export const BOX_TEXT = 'Ships in a box.'
export const CRATE_PACKAGING_TEXT =
  'Ships in a wooden crate for additional protection of heavy or oversized artworks.'

export const PRINT_DEPTH = 1.2 // for framed print (in inches)

export const CANVAS_PRINT_DEPTH = 1.25 // in inches

export const CANVAS_WRAP_FRAME_SIZE_IN_INCHES = 0.625
export const CANVAS_WRAP_GAP_SIZE_IN_INCHES = 0.25 // gap between canvas and frame

// constants for USP section
export const USPList = [
  {
    image: <BadgesStarIcon width={40} height={40} />,
    title: 'Thousands of 5-Star Reviews',
    description: 'We deliver world-class customer service to all of our art buyers.',
  },
  {
    image: <BadgesSmileIcon width={40} height={40} />,
    title: 'Satisfaction Guaranteed',
    description: 'Our 14-day satisfaction guarantee allows you to buy with confidence.',
  },
  {
    image: <BadgesGlobeIcon width={40} height={40} />,
    title: 'Global Selection of Emerging Art',
    description: 'Explore an unparalleled artwork selection by artists from around the world.',
  },
  {
    image: <BadgesDollarIcon width={40} height={40} />,
    title: 'Support An Artist With Every Purchase',
    description: 'We pay our artists more on every sale than other galleries.',
  },
]

// gallery spec images
export const PAPER_PRINT_FRAME_IMAGE = {
  imageUrl: 'https://d3t95n9c6zzriw.cloudfront.net/art-detail/Product_Detail_Frames.jpg',
  width: 1662,
  height: 1106,
  thumbnailUrl: 'https://d3t95n9c6zzriw.cloudfront.net/art-detail/Product_Detail_Thumbnail.jpg',
}
export const CANVAS_WRAP_FRAME_IMAGE_WHITE = {
  imageUrl:
    'https://d3t95n9c6zzriw.cloudfront.net/art-detail/canvas-wrap-frame-white-detail-2x.jpg',
  width: 1662,
  height: 1814,
  thumbnailUrl:
    'https://d3t95n9c6zzriw.cloudfront.net/art-detail/canvas-wrap-frame-white-detail-thumbnail.jpg',
}
export const CANVAS_WRAP_FRAME_IMAGE_BLACK = {
  imageUrl:
    'https://d3t95n9c6zzriw.cloudfront.net/art-detail/canvas-wrap-frame-black-detail-2x.jpg',
  width: 1662,
  height: 1814,
  thumbnailUrl:
    'https://d3t95n9c6zzriw.cloudfront.net/art-detail/canvas-wrap-frame-black-detail-thumbnail.jpg',
}
export const LIMITED_AUTHENTICITY_IMAGE = {
  imageUrl:
    'https://d3t95n9c6zzriw.cloudfront.net/static/img/certificate-of-authenticity-numbered.jpg',
  width: 1662,
  height: 1106,
  thumbnailUrl:
    'https://d3t95n9c6zzriw.cloudfront.net/static/img/certificate-of-authenticity-numbered-thumb.jpg',
}
export const PAPER_PRINT_FRAME_BACKING_IMAGE = {
  imageUrl: 'https://d3t95n9c6zzriw.cloudfront.net/static/img/white-frame-backing.jpg',
  width: 1662,
  height: 1109,
  thumbnailUrl: 'https://d3t95n9c6zzriw.cloudfront.net/static/img/white-frame-backing-thumb.jpg',
}
export const CANVAS_WRAP_FRAME_BACKING_IMAGE = {
  imageUrl: 'https://d3t95n9c6zzriw.cloudfront.net/art-detail/canvas-wrap-frame-back-2x.jpg',
  width: 1662,
  height: 1109,
  thumbnailUrl:
    'https://d3t95n9c6zzriw.cloudfront.net/art-detail/canvas-wrap-frame-back-thumbnail.jpg',
}
export const PAPER_PRINT_SPECS_IMAGE = {
  imageUrl: 'https://d3t95n9c6zzriw.cloudfront.net/art-detail/Specs2.jpg',
  width: 1658,
  height: 1109,
  thumbnailUrl: 'https://d3t95n9c6zzriw.cloudfront.net/art-detail/Specs_Thumbnail2.jpg',
}
export const CANVAS_WRAP_PRINT_SPECS_IMAGE = {
  imageUrl: 'https://d3t95n9c6zzriw.cloudfront.net/art-detail/canvas-wrap-frame-spec-2-2x.jpg',
  width: 1658,
  height: 1146,
  thumbnailUrl:
    'https://d3t95n9c6zzriw.cloudfront.net/art-detail/canvas-wrap-frame-spec-2-thumbnail.jpg',
}
export const ACRYLIC_FRAME_IMAGE = {
  imageUrl: 'https://d3t95n9c6zzriw.cloudfront.net/art-detail/Product_Detail_Acrylic2.jpg',
  width: 1662,
  height: 1106,
  thumbnailUrl: 'https://d3t95n9c6zzriw.cloudfront.net/art-detail/Product_Thumbnail_Acrylic2.jpg',
}
export const ACRYLIC_FRAME_BACKING_IMAGE = {
  imageUrl: 'https://d3t95n9c6zzriw.cloudfront.net/art-detail/Backing_Acrylic_print2.jpg',
  width: 1662,
  height: 1106,
  thumbnailUrl: 'https://d3t95n9c6zzriw.cloudfront.net/art-detail/Backing_Acrylic_Thumbnail.jpg',
}
export const ACRYLIC_SPECS_IMAGE = {
  imageUrl: 'https://d3t95n9c6zzriw.cloudfront.net/art-detail/Spec_Detail_Acrylic2.jpg',
  width: 1658,
  height: 1109,
  thumbnailUrl:
    'https://d3t95n9c6zzriw.cloudfront.net/art-detail/Specs_Detail_Thumbnail_Acrylic2.jpg',
}
export const METAL_FRAME_IMAGE = {
  imageUrl: 'https://d3t95n9c6zzriw.cloudfront.net/art-detail/Product_Detail_Metal3.jpg',
  width: 1662,
  height: 1106,
  thumbnailUrl:
    'https://d3t95n9c6zzriw.cloudfront.net/art-detail/Product_Detail_Thumbnail_Metal3.jpg',
}
export const METAL_FRAME_BACKING_IMAGE = {
  imageUrl: 'https://d3t95n9c6zzriw.cloudfront.net/art-detail/Backing_Metal2.jpg',
  width: 1662,
  height: 1109,
  thumbnailUrl: 'https://d3t95n9c6zzriw.cloudfront.net/art-detail/Backing_Metal_Thumbnail.jpg',
}
export const METAL_SPECS_IMAGE = {
  imageUrl: 'https://d3t95n9c6zzriw.cloudfront.net/art-detail/Specs_Detail_Metal3.jpg',
  width: 1658,
  height: 1146,
  thumbnailUrl:
    'https://d3t95n9c6zzriw.cloudfront.net/art-detail/Specs_Detail_Thumbnail_Metal3.jpg',
}
